import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import CounterSection from './CounterSection';

import credit from '../assets/mobile-app-developers.webp';
import carLoan from '../assets/yellobus3.jpg';
import yellowWoman from '../assets/datafm3.jpg';
import home from '../assets/coding.jpg';
import ServicesSection from './ServicesSection';
import BusinessSection from './BusinessSection';
import backgroundImage from '../assets/yellobus.jpg';
import PartnersPage from './Partners';

const images = [credit, carLoan, yellowWoman, home];

function Home() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change slide every 6 seconds
    return () => clearInterval(interval);
  }, []);

  const slideInStyles = {
    animation: 'slideIn 2.5s ease-out forwards',
    transform: 'scale(1.2)',
    opacity: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  };

  const slideOutStyles = {
    animation: 'slideOut 2.5s ease-in forwards',
    transform: 'scale(1)',
    opacity: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  };

  return (
    <section className="w-full">
      <div className="mt-8 relative h-96 md:h-96 lg:h-[41.2rem]">
        {images.map((image, index) => (
          <div
            key={index}
            className={`absolute top-0 left-0 w-full h-full duration-[2.5s] ease-in-out ${
              currentIndex === index ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <div className="absolute inset-0 bg-black bg-opacity-40"></div> {/* Overlay */}
            <img src={image} alt={`Slide ${index + 1}`} className="w-full h-full object-cover" />
            <div
              className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl transition-opacity duration-[2.5s] ease-in-out ${
                currentIndex === index ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <div
                className="text-center text-white p-4 rounded-lg items-justify"
                style={currentIndex === index ? slideInStyles : slideOutStyles}
              >
                <h2 className="text-base text-xl sm:text-4xl md:text-4xl font-semibold mb-4 justify-content">
                  {index === 0 && 'Digital Services'}
                  {index === 1 && 'Storage Solutions'}
                  {index === 2 && 'Server Solutions'}
                  {index === 3 && 'Software Development'}
                </h2>
                <p className="text-base sm:text-lg md:text-xl mb-6">
                  {index === 0 && 'Optimize Computing with the latest infrastructure from our global partners, enterprise IT infrastructure, and Managed IT services'}
                  {index === 1 && 'Network Attached Storage (NAS) for robust, on-premises data storage.'}
                  {index === 2 && 'Scalable cloud server management for optimal reliability.'}
                  {index === 3 && 'We Create secure, high-performing websites, mobile and systems applications.'}
                </p>
                <Link to="/ContactPage">
                  <button className="bg-[#C5B358] text-blue-900 font-semibold py-2 sm:py-3 px-4 sm:px-6 md:px-8 rounded-full transition-transform duration-500 ease-in-out transform hover:scale-105">
                    Contact Us
                  </button>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
      <ServicesSection />
      <BusinessSection />
      <div
        className='text-center my-8 relative w-full h-64 bg-cover bg-center bg-no-repeat'
        style={{ backgroundImage: `url(${backgroundImage})`, backgroundAttachment: 'fixed' }}
      >                                                                                     <br />
        <h1 className="text-xl font-semibold animate-slide-in text-white">Why Choose Us?</h1><br />
        <h1 className="text-white text-2xl font-semibold animate-slide-in">We Are Trusted Nationwide</h1>
        <div>
          <CounterSection />
        </div>
      </div>
      <PartnersPage />
     
      <style>
        {`
          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          @keyframes slideOut {
            from {
              opacity: 1;
              transform: translateY(0);
            }
            to {
              opacity: 0;
              transform: translateY(-20px);
            }
          }
          .animate-slide-in {
            animation: slideIn 2.5s ease-out forwards;
          }
        `}
      </style>
    </section>
  );
}

export default Home;
